import { render, staticRenderFns } from "./ProviderWrapper.vue?vue&type=template&id=4e80f53e"
import script from "./ProviderWrapper.vue?vue&type=script&lang=js"
export * from "./ProviderWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e80f53e')) {
      api.createRecord('4e80f53e', component.options)
    } else {
      api.reload('4e80f53e', component.options)
    }
    module.hot.accept("./ProviderWrapper.vue?vue&type=template&id=4e80f53e", function () {
      api.rerender('4e80f53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/ProviderWrapper.vue"
export default component.exports